import React from 'react';
import PropTypes from 'prop-types';

// import hooks
import useKenwoodClosingFilters from '@/hooks/listing/Kenwood/useKenwoodClosingFilters';

// import components
import FacetValue from '@/kenwood/components/molecules/FacetValue';

const FacetMobile = ({ areMobileFiltersOpen, facet, onApplyFilter }) => {
  const checkboxRef = useKenwoodClosingFilters(areMobileFiltersOpen);
  return (
    <section key={facet.code} className='ken-simple-css-accordion'>
      <input ref={checkboxRef} type='checkbox' id={facet.code} />
      <div className='ken-simple-css-accordion__wrapper'>
        <label
          htmlFor={facet.code}
          className={`ken-simple-css-accordion__title ${
            facet.selectedCount ? '--has-selected-filters' : ''
          }`}
        >
          <span className='ken-simple-css-accordion__label'>
            {facet.name}
            {facet.selectedCount ? ` (${facet.selectedCount})` : ''}
          </span>
          <i className='ken-simple-css-accordion__icon' />
        </label>
        <div className='ken-simple-css-accordion__content'>
          {facet.values.map((value, index) => (
            <FacetValue
              key={value.code}
              facetCode={facet.code}
              value={value}
              isLast={facet.values.length === index + 1}
              onApplyFilter={onApplyFilter}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

FacetMobile.propTypes = {
  areMobileFiltersOpen: PropTypes.bool,
  facet: PropTypes.shape(),
  onApplyFilter: PropTypes.func,
};

FacetMobile.defaultProps = {
  areMobileFiltersOpen: false,
  facet: null,
  onApplyFilter: null,
};

export default FacetMobile;

// MOUSE OVER EVENT
//  remove useOnClickOutside hook
//  ken-plp__filters__desktop-bar__sort
//    onMouseOut={() => setIsOpen(false)}
//    onBlur={() => setIsOpen(false)}
//    onMouseOver={() => setIsOpen(true)}
//    onFocus={() => setIsOpen(true)}
//  button
//    no events
//  scss
//    some tweaks and a new wrapper probably
